module.exports = {
  SIGN_IN: 'साइन इन करें',
  MSG_VAL_TEXT_NOT_EMPTY_NO_SPACE: '{label} एक अनिवार्य इनपुट है और इसमें रिक्त स्थान नहीं हो सकते हैं',
  MSG_VAL_TEXT_MIN_CHAR_COUNT: 'कम से कम {text_min_char_count} वर्ण होने चाहिए',
  MSG_VAL_TEXT_MAX_CHAR_COUNT: 'अधिकतम {text_max_char_count} वर्ण होने चाहिए',
  MSG_VAL_TEXT_TEL_NUMBER: 'कृपया एक मान्य मोबाइल फ़ोन नंबर दर्ज करें',
};
